/*
  VEKTRA · Interfaz global
  Encabezado, megamenú, cajones, buscador predictivo, carrito AJAX, vista rápida, pestañas, rieles y recomendaciones.
*/
(function () {
  'use strict';

  var T = window.vkTheme || { routes: {}, strings: {} };
  var S = T.strings || {};

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function contentChanged(scope) {
    if (window.vkMotion) window.vkMotion.observe(scope || document);
    document.dispatchEvent(new CustomEvent('vk:content', { detail: { scope: scope || document } }));
  }

  /* ---------- Dinero (formato de la tienda) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Avisos ---------- */
  function toast(html, ms) {
    var region = $('[data-vk-toasts]');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'vk-toast';
    el.innerHTML = html;
    region.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-leaving');
      setTimeout(function () {
        el.remove();
      }, 300);
    }, ms || 3600);
  }

  /* ---------- Capas: cajones y modales ---------- */
  var stack = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function layerEl(id) {
    return document.getElementById(id);
  }

  function openLayer(id, trigger) {
    var el = layerEl(id);
    if (!el || el.classList.contains('is-open')) return;
    stack.push({ el: el, trigger: trigger || document.activeElement });
    el.classList.add('is-open');
    var ov = $('[data-vk-overlay="' + id + '"]');
    if (ov) ov.classList.add('is-open');
    document.body.classList.add('vk-lock');
    $$('[aria-controls="' + id + '"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
    setTimeout(function () {
      var first = $('input[type="search"], [data-autofocus]', el) || el;
      try {
        first.focus({ preventScroll: true });
      } catch (e) {}
    }, 60);
    el.dispatchEvent(new CustomEvent('vk:open'));
  }

  function closeLayer(el) {
    if (!el) {
      var top = stack[stack.length - 1];
      if (!top) return;
      el = top.el;
    }
    var idx = -1;
    stack.forEach(function (s, i) {
      if (s.el === el) idx = i;
    });
    var entry = idx > -1 ? stack.splice(idx, 1)[0] : null;
    el.classList.remove('is-open');
    var ov = $('[data-vk-overlay="' + el.id + '"]');
    if (ov) ov.classList.remove('is-open');
    $$('[aria-controls="' + el.id + '"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    if (!stack.length) document.body.classList.remove('vk-lock');
    if (entry && entry.trigger && entry.trigger.focus) {
      try {
        entry.trigger.focus({ preventScroll: true });
      } catch (e) {}
    }
    el.dispatchEvent(new CustomEvent('vk:close'));
  }

  function trapFocus(e) {
    var top = stack[stack.length - 1];
    if (!top || e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, top.el).filter(function (n) {
      return n.offsetParent !== null || n === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------- Barra de anuncios ---------- */
  function initAnnouncement() {
    var bar = $('[data-vk-announce]');
    if (!bar) return;
    var msgs = $$('.vk-announce__msg', bar);
    if (msgs.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    var i = 0;
    var paused = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) bar.classList.add('is-running');
    bar.addEventListener('mouseenter', function () {
      paused = true;
    });
    bar.addEventListener('mouseleave', function () {
      paused = false;
    });
    bar.addEventListener('focusin', function () {
      paused = true;
    });
    bar.addEventListener('focusout', function () {
      paused = false;
    });
    setInterval(function () {
      if (paused || document.hidden) return;
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      var next = msgs[i];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      next.classList.remove('is-leaving');
      next.classList.add('is-active');
      setTimeout(function () {
        cur.classList.remove('is-leaving');
      }, 600);
    }, interval);
  }

  /* ---------- Megamenú ---------- */
  function initMega() {
    var header = $('[data-vk-header]');
    if (!header) return;
    var triggers = $$('[data-vk-mega-trigger]', header);
    if (!triggers.length) return;
    var openId = null;
    var hoverT;
    var canHover = window.matchMedia('(hover: hover)').matches;

    function show(id) {
      if (openId === id) return;
      hideAll();
      var panel = document.getElementById(id);
      if (!panel) return;
      panel.classList.add('is-open');
      var t = $('[data-vk-mega-trigger="' + id + '"]', header);
      if (t) t.setAttribute('aria-expanded', 'true');
      openId = id;
    }

    function hideAll() {
      $$('[data-vk-mega]', header).forEach(function (p) {
        p.classList.remove('is-open');
      });
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      openId = null;
    }

    triggers.forEach(function (t) {
      var id = t.getAttribute('data-vk-mega-trigger');
      t.addEventListener('click', function () {
        if (openId === id) hideAll();
        else show(id);
      });
      if (canHover) {
        t.addEventListener('mouseenter', function () {
          clearTimeout(hoverT);
          hoverT = setTimeout(function () {
            show(id);
          }, 110);
        });
      }
    });

    if (canHover) {
      header.addEventListener('mouseleave', function () {
        clearTimeout(hoverT);
        hoverT = setTimeout(hideAll, 220);
      });
      header.addEventListener('mouseenter', function () {
        clearTimeout(hoverT);
      });
      $$('.vk-nav__item > a', header).forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          clearTimeout(hoverT);
          hoverT = setTimeout(hideAll, 110);
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openId) {
        var t = $('[data-vk-mega-trigger="' + openId + '"]', header);
        hideAll();
        if (t) t.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (openId && !header.contains(e.target)) hideAll();
    });
    header.addEventListener('focusout', function (e) {
      if (openId && !header.contains(e.relatedTarget)) hideAll();
    });
  }

  /* ---------- Buscador predictivo ---------- */
  function initSearch() {
    var wrap = $('[data-vk-search]');
    if (!wrap) return;
    var input = $('[data-vk-search-input]', wrap);
    var results = $('[data-vk-ps-results]', wrap);
    var def = $('[data-vk-ps-default]', wrap);
    var predictive = wrap.getAttribute('data-predictive') !== 'false';
    var controller = null;
    var cache = {};

    function open(trigger) {
      openLayer('vk-search', trigger);
      setTimeout(function () {
        input.focus();
        input.select();
      }, 80);
    }

    function setLive(html) {
      var live = $('[data-vk-ps-live]', results);
      if (live) live.remove();
      if (html === null) {
        if (def) def.hidden = false;
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      if (def) def.hidden = true;
      results.insertAdjacentHTML('beforeend', html);
      input.setAttribute('aria-expanded', 'true');
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (!predictive) return;
      if (q.length < 2) {
        setLive(null);
        return;
      }
      if (cache[q]) {
        setLive(cache[q]);
        return;
      }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      wrap.classList.add('is-loading');
      var url =
        T.routes.predictiveSearch +
        '?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=vk-predictive-search';
      fetch(url, { signal: controller ? controller.signal : undefined })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = parseHTML(html);
          var live = doc.querySelector('[data-vk-ps-live]');
          var out = live ? live.outerHTML : '';
          cache[q] = out;
          if (input.value.trim() === q) setLive(out);
        })
        .catch(function () {})
        .finally(function () {
          wrap.classList.remove('is-loading');
        });
    }, 220);

    input.addEventListener('input', run);

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
      var options = $$('[data-vk-ps-option]', results).filter(function (o) {
        return o.offsetParent !== null;
      });
      if (!options.length) return;
      var current = options.findIndex(function (o) {
        return o.getAttribute('aria-selected') === 'true';
      });
      if (e.key === 'Enter') {
        if (current > -1) {
          e.preventDefault();
          options[current].click();
        }
        return;
      }
      e.preventDefault();
      var next = e.key === 'ArrowDown' ? current + 1 : current - 1;
      if (next < 0) next = options.length - 1;
      if (next >= options.length) next = 0;
      options.forEach(function (o) {
        o.setAttribute('aria-selected', 'false');
      });
      options[next].setAttribute('aria-selected', 'true');
      options[next].scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-vk-search-open]');
      if (t) {
        e.preventDefault();
        open(t);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag) || (document.activeElement && document.activeElement.isContentEditable)) return;
      e.preventDefault();
      open();
    });

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) closeLayer(wrap);
    });
  }

  /* ---------- Carrito ---------- */
  function updateCount(count) {
    $$('[data-vk-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      if (count > 0) el.classList.add('is-bumped');
    });
    $$('[data-vk-cart-link]').forEach(function (a) {
      var label = a.getAttribute('aria-label') || '';
      a.setAttribute('aria-label', label.replace(/\d+/, count));
    });
  }

  function drawer() {
    return $('[data-vk-cart-drawer]');
  }

  function renderDrawer(html) {
    var current = drawer();
    if (!current || !html) return;
    var doc = parseHTML(html);
    var fresh = doc.querySelector('[data-vk-cart-drawer]');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    var count = parseInt(fresh.getAttribute('data-count'), 10);
    if (!isNaN(count)) updateCount(count);
    loadCartReco();
    contentChanged(current);
  }

  function renderCartPage(sections) {
    var page = $('[data-vk-cart-page]');
    if (!page || !sections) return;
    var id = page.getAttribute('data-section-id');
    if (!sections[id]) return;
    var doc = parseHTML(sections[id]);
    var fresh = doc.querySelector('[data-vk-cart-page]');
    if (fresh) {
      page.innerHTML = fresh.innerHTML;
      contentChanged(page);
    }
  }

  function sectionIds() {
    var ids = [];
    if (drawer()) ids.push('vk-cart-drawer');
    var page = $('[data-vk-cart-page]');
    if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }

  function openCart(trigger) {
    if (!drawer()) {
      window.location.href = T.routes.cart;
      return;
    }
    openLayer('vk-cart', trigger);
    loadCartReco();
  }

  function loadCartReco() {
    var box = $('[data-vk-cart-reco]');
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    fetch(box.getAttribute('data-url'))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = parseHTML(html);
        var sec = doc.querySelector('.shopify-section') || doc.body;
        box.innerHTML = sec.innerHTML;
        contentChanged(box);
      })
      .catch(function () {});
  }

  function addToCart(form, btn) {
    var errorEl = $('[data-vk-form-error]', form);
    if (errorEl) {
      errorEl.classList.remove('is-visible');
      errorEl.textContent = '';
    }
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
    }
    var data = new FormData(form);
    var ids = sectionIds();
    if (ids.length) {
      data.append('sections', ids.join(','));
      data.append('sections_url', window.location.pathname);
    }
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) {
        return r.json().then(function (json) {
          return { ok: r.ok, json: json };
        });
      })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var msg = res.json.description || res.json.message || S.error;
          if (errorEl) {
            errorEl.textContent = msg;
            errorEl.classList.add('is-visible');
          } else {
            toast(msg);
          }
          return;
        }
        var sections = res.json.sections || {};
        if (sections['vk-cart-drawer']) {
          renderDrawer(sections['vk-cart-drawer']);
          renderCartPage(sections);
          closeLayer($('#vk-quick.is-open'));
          openCart(btn);
        } else {
          fetch(T.routes.cart + '.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              updateCount(cart.item_count);
            });
          toast((S.added || 'Agregado') + ' <a href="' + T.routes.cart + '" style="color:inherit;text-decoration:underline;margin-left:auto">' + (S.viewCart || 'Ver carrito') + '</a>');
        }
        document.dispatchEvent(new CustomEvent('vk:cart:added', { detail: res.json }));
      })
      .catch(function () {
        toast(S.error || 'Algo salió mal. Intenta de nuevo.');
      })
      .finally(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');
        }
      });
  }

  function changeLine(line, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-busy');
    var page = $('[data-vk-cart-page]');
    if (page) page.style.opacity = '0.6';
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart.status) {
          toast(cart.description || cart.message || S.error);
          return;
        }
        updateCount(cart.item_count);
        if (cart.sections) {
          if (cart.sections['vk-cart-drawer']) renderDrawer(cart.sections['vk-cart-drawer']);
          renderCartPage(cart.sections);
        }
      })
      .catch(function () {
        toast(S.error || 'Algo salió mal. Intenta de nuevo.');
      })
      .finally(function () {
        var d2 = drawer();
        if (d2) d2.classList.remove('is-busy');
        var p2 = $('[data-vk-cart-page]');
        if (p2) p2.style.opacity = '';
      });
  }

  var saveNote = debounce(function (value) {
    fetch(T.routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    });
  }, 500);

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-vk-add-form], [data-vk-product-form]')) return;
      e.preventDefault();
      var btn = e.submitter || $('[type="submit"]', form);
      addToCart(form, btn);
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-vk-cart-open]');
      if (link && T.cartType !== 'page' && drawer()) {
        e.preventDefault();
        openCart(link);
        return;
      }
      var lines = e.target.closest('[data-vk-cart-lines]');
      if (!lines) return;
      var li = e.target.closest('[data-line]');
      if (!li) return;
      var line = parseInt(li.getAttribute('data-line'), 10);
      var input = $('[data-vk-line-input]', li);
      if (e.target.closest('[data-vk-line-remove]')) {
        changeLine(line, 0);
        return;
      }
      var step = e.target.closest('[data-vk-qty-step]');
      if (step && input) {
        var inc = parseInt(input.getAttribute('step'), 10) || 1;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + inc * parseInt(step.getAttribute('data-vk-qty-step'), 10));
        input.value = next;
        changeLine(line, next);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-vk-line-input]');
      if (input) {
        var li = input.closest('[data-line]');
        changeLine(parseInt(li.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      }
    });

    document.addEventListener('input', function (e) {
      if (e.target.matches('[data-vk-cart-note]')) saveNote(e.target.value);
    });

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fetch(T.routes.cart + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          updateCount(cart.item_count);
        });
    });
  }

  /* ---------- Vista rápida ---------- */
  function ensureProductScript() {
    if (window.vkProduct) return Promise.resolve();
    return new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = (T.assets && T.assets.product) || '';
      s.onload = resolve;
      s.onerror = resolve;
      document.head.appendChild(s);
    });
  }

  function quickView(url, btn) {
    var holder = $('[data-vk-quick-content]');
    if (!holder) {
      window.location.href = url;
      return;
    }
    if (btn) btn.classList.add('is-loading');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    Promise.all([
      fetch(url + sep + 'section_id=vk-quick-view').then(function (r) {
        return r.text();
      }),
      ensureProductScript()
    ])
      .then(function (out) {
        var doc = parseHTML(out[0]);
        var pdp = doc.querySelector('[data-vk-product]');
        if (!pdp) {
          window.location.href = url;
          return;
        }
        holder.innerHTML = '';
        holder.appendChild(document.importNode(pdp, true));
        if (window.vkProduct) window.vkProduct.init(holder);
        openLayer('vk-quick', btn);
        contentChanged(holder);
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  /* ---------- Pestañas ---------- */
  function initTabs(scope) {
    $$('[data-vk-tabs]', scope).forEach(function (list) {
      if (list.dataset.vkBound) return;
      list.dataset.vkBound = '1';
      var tabs = $$('[role="tab"]', list);
      var bar = $('.vk-tabs__bar', list);
      function moveBar(tab) {
        if (!bar || !tab) return;
        bar.style.setProperty('--x', tab.offsetLeft + 'px');
        bar.style.setProperty('--w', tab.offsetWidth + 'px');
      }
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        moveBar(tab);
        if (focus) tab.focus();
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) contentChanged(panel);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          select(t);
        });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) {
            e.preventDefault();
            select(n, true);
          }
        });
      });
      var current =
        tabs.filter(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        })[0] || tabs[0];
      requestAnimationFrame(function () {
        moveBar(current);
      });
      window.addEventListener('resize', debounce(function () {
        moveBar(
          tabs.filter(function (t) {
            return t.getAttribute('aria-selected') === 'true';
          })[0]
        );
      }, 120));
    });
  }

  /* ---------- Rieles deslizables ---------- */
  function initSliders(scope) {
    $$('[data-vk-slider]', scope).forEach(function (slider) {
      if (slider.dataset.vkBound) return;
      slider.dataset.vkBound = '1';
      var track = $('[data-vk-slider-track]', slider);
      var prog = $('[data-vk-slider-progress]', slider);
      var prev = $('[data-vk-slider-prev]', slider);
      var next = $('[data-vk-slider-next]', slider);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var p = track.scrollWidth ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1;
        if (prog) prog.style.setProperty('--p', Math.min(1, p).toFixed(3));
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      track.addEventListener('scroll', function () {
        requestAnimationFrame(update);
      }, { passive: true });
      if (prev)
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' });
        });
      if (next)
        next.addEventListener('click', function () {
          track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
        });
      window.addEventListener('resize', debounce(update, 120));
      update();
    });
  }

  /* ---------- Recomendaciones ---------- */
  function initRecommendations() {
    $$('[data-vk-recommendations]').forEach(function (sec) {
      var url = sec.getAttribute('data-url');
      if (!url || sec.dataset.loaded) return;
      function load() {
        if (sec.dataset.loaded) return;
        sec.dataset.loaded = '1';
        fetch(url)
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var doc = parseHTML(html);
            var fresh = doc.querySelector('[data-vk-recommendations]');
            if (fresh && fresh.innerHTML.trim()) {
              sec.innerHTML = fresh.innerHTML;
              initSliders(sec);
              contentChanged(sec);
            } else {
              sec.hidden = true;
            }
          })
          .catch(function () {});
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              io.disconnect();
              load();
            }
          },
          { rootMargin: '400px 0px' }
        );
        io.observe(sec);
      } else {
        load();
      }
    });
  }

  /* ---------- Delegación general ---------- */
  function initGlobalEvents() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-vk-open]');
      if (opener) {
        e.preventDefault();
        openLayer(opener.getAttribute('data-vk-open'), opener);
        return;
      }
      var closer = e.target.closest('[data-vk-close]');
      if (closer) {
        e.preventDefault();
        closeLayer(closer.closest('.vk-drawer, .vk-modal, .vk-search, .vk-lightbox'));
        return;
      }
      var ov = e.target.closest('[data-vk-overlay]');
      if (ov) {
        closeLayer(document.getElementById(ov.getAttribute('data-vk-overlay')));
        return;
      }
      var qv = e.target.closest('[data-vk-quick-view]');
      if (qv) {
        e.preventDefault();
        quickView(qv.getAttribute('data-vk-quick-view'), qv);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && stack.length) {
        e.preventDefault();
        closeLayer();
      }
      trapFocus(e);
    });

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-vk-localization] select');
      if (sel) sel.form.submit();
    });

    // Al pasar a computadora, el cajón de filtros se vuelve columna: libera el bloqueo
    window.addEventListener(
      'resize',
      debounce(function () {
        if (window.innerWidth >= 990) {
          var f = document.getElementById('vk-facets');
          if (f && f.classList.contains('is-open') && f.closest('.vk-coll--sidebar')) closeLayer(f);
        }
      }, 150)
    );

    document.addEventListener('shopify:section:load', function (e) {
      initTabs(e.target);
      initSliders(e.target);
      initRecommendations();
      contentChanged(e.target);
    });
  }

  /* ---------- Apps: filtro y búsqueda de TrustZ ----------
     TrustZ reemplaza la rejilla de colección y búsqueda con la suya. Muestra el precio de comparación aunque sea igual
     o menor que el precio, lo que se lee como un descuento que no existe: aquí sólo se deja cuando de verdad es mayor. */
  function initAppBridge() {
    var main = document.getElementById('MainContent');
    if (!main || !('MutationObserver' in window)) return;
    var queued = false;

    function cents(el) {
      return parseInt((el.textContent || '').replace(/\D/g, ''), 10);
    }

    function fixPrices() {
      queued = false;
      Array.prototype.forEach.call(main.querySelectorAll('.tz-fs__price-row'), function (row) {
        if (row.getAttribute('data-vk-checked') === row.textContent) return;
        var now = row.querySelector('.tz-fs__price-new');
        var old = row.querySelector('.tz-fs__price-old');
        if (now && old) old.hidden = !(cents(old) > cents(now));
        row.setAttribute('data-vk-checked', row.textContent);
      });
    }

    // Temporizador y no requestAnimationFrame: también corre si la página se abrió en una pestaña de fondo
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(fixPrices, 50);
    }).observe(main, { childList: true, subtree: true });
    fixPrices();
  }

  window.vkUI = {
    formatMoney: formatMoney,
    toast: toast,
    openLayer: openLayer,
    closeLayer: closeLayer,
    addToCart: addToCart,
    contentChanged: contentChanged,
    initSliders: initSliders
  };

  function boot() {
    initGlobalEvents();
    initAnnouncement();
    initMega();
    initSearch();
    initCart();
    initTabs();
    initSliders();
    initRecommendations();
    initAppBridge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
